import { createContext, useContext, useState } from 'react'
import { toast, Toaster } from 'sonner'
import { twMerge } from 'tailwind-merge'

const FlashMessageContext = createContext()

const FlashMessageProvider = ({ children }) => {
  const setFlashMessage = (message, theme = 'primary', description = null) => {
    const baseOptions = {
      description: description,
    }
    
    // Define a single button class for all toasts
    const buttonClassName = '!bg-transparent !border !border-black !text-black hover:!bg-gray-100 !rounded !px-2 !py-1'
    
    // Define emojis for different themes
    const themeEmojis = {
      success: '✅',
      error: '❌',
      secondary: '💜',
      info: '🔔',
      primary: '🔔'
    }
    
    // Get the appropriate emoji based on theme
    const emoji = themeEmojis[theme] || themeEmojis.primary

    // Style for secondary toast
    const secondaryStyle = theme === 'secondary' 
      ? { background: '#EDE9FE', borderColor: '#6B21A8' }
      : {}
    
    // Use the default toast for all cases with different emojis
    toast(message, {
      ...baseOptions,
      icon: emoji,
      style: secondaryStyle,
      classNames: { 
        actionButton: buttonClassName,
        toast: "group",
        icon: "!self-start !mt-1"
      },
      action: {
        label: 'Close',
        onClick: (id) => toast.dismiss(id),
      }
    })
  }

  const clearFlashMessage = () => {
    toast.dismiss()
  }

  return (
    <FlashMessageContext.Provider value={{ setFlashMessage, clearFlashMessage }}>
      {children}
      <Toaster 
        position="bottom-right"
      />
    </FlashMessageContext.Provider>
  )
}

const useFlashMessage = () => {
  const context = useContext(FlashMessageContext)

  if (!context) {
    throw new Error('useFlashMessage must be used within a FlashMessageProvider')
  }

  return context
}

const FlashMessage = () => {
  // This component is now just a placeholder as Toaster is rendered in the provider
  return null
}

export default FlashMessage

export { FlashMessageProvider, useFlashMessage }
